module.exports = __webpack_public_path__ + "static/media/Mapa-Bahia.3995ae48.svg";